export const UNIVERSAL_DATA_EXPORT_FETCHING = 'UNIVERSAL_DATA_EXPORT_FETCHING';
export const UNIVERSAL_DATA_EXPORT_FETCH_ERROR =
  'UNIVERSAL_DATA_EXPORT_FETCH_ERROR';
export const UNIVERSAL_DATA_EXPORT_CLEAR_ERRORS =
  'UNIVERSAL_DATA_EXPORT_CLEAR_ERRORS';
export const UNIVERSAL_DATA_EXPORT_FETCH_SUCCESS =
  'UNIVERSAL_DATA_EXPORT_FETCH_SUCCESS';



// WEBPACK FOOTER //
// ./src/pages/universaldataexport/state/types.js